import { memo, useCallback, useMemo, useState } from 'react';
import { Drawer, IconButton, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment/moment';

const NotificationDrawer = ({ open, setOpen, data }) => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState('all');
  const onChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const getLink = useCallback((type, id) => {
    switch (type) {
      case '1':
        return `/admin/crm/lead/edit/${id}`;

      default:
        return '';
    }
  }, []);

  const notifications = useMemo(() => {
    if (tabValue === 'all') {
      return data;
    }
    return data?.filter((notification) => {
      if (tabValue === 'unread') {
        return !notification.isread;
      }
      if (tabValue === 'read') {
        return notification.isread;
      }
      return false;
    });
  }, [data, tabValue]);

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        className: 'w-[450px]',
        sx: { padding: '18px', background: 'transparent', boxShadow: 'none' },
      }}
    >
      <div className='flex flex-col first-letter bg-white h-full rounded-lg border border-[#E5E9EB]'>
        <div className='border-b flex items-center justify-between pr-16 relative'>
          <div className='drawer-title p-2 pl-6 font-semibold text-lg'>
            <span className='mr-4'>{t('common.global.notifications')}</span>
          </div>

          <div className='close-btn-wrapper'>
            <IconButton
              variant='onlyIcon'
              color='primary'
              onClick={() => setOpen(false)}
            >
              <i className='bi bi-x' />
            </IconButton>
          </div>
        </div>
        <div className='menu-list'>
          <Tabs value={tabValue} onChange={onChangeTab}>
            <Tab label={t('boss.crm.calls.all')} value={'all'} />
            <Tab label={t('common.button.unread')} value={'unread'} />
            <Tab label={t('common.button.read')} value={'read'} />
          </Tabs>
        </div>
        <div className='grow overflow-y-auto my-scroll'>
          {notifications?.length ? (
            <div>
              {notifications.map((notification) => (
                <Link
                  to={getLink(notification?.type?.toString(), notification.id)}
                  key={notification.id}
                  className='no-underline block p-4 border-b last:border-0 hover:bg-gray-100 cursor-pointer'
                >
                  <div className='flex gap-4 relative'>
                    <div className='icon pt-2'>
                      <div className='rounded-full w-8 h-8 text-white bg-red-400 flex shadow-[0_0_15px_rgb(248,113,113,1)] items-center justify-center'>
                        <i className='bi bi-bell' />
                      </div>
                    </div>
                    <div className='grow'>
                      <div className='font-semibold text-sm mb-1 relative'>
                        {notification.type_name}
                        {!notification?.isread && (
                          <span className='w-2 h-2 bg-red-500 rounded-full absolute top-1/2 right-0 -translate-y-1/1' />
                        )}
                      </div>
                      <div className='text-sm text-gray-600'>
                        {notification.text}
                      </div>

                      <div className='flex justify-end items-center'>
                        <span className='text-[11px] text-gray-400 leading-none'>
                          {moment(
                            notification?.date,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('DD.MM.YYYY HH:mm')}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className='p-4 text-base text-gray-400'>
              {t('common.global.noNotifications')}
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
};
export default memo(NotificationDrawer);
